import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import BanksPage from './pages/BanksPage';
import CreditCardsPage from './pages/CreditCardsPage';
import CategoriesPage from './pages/CategoriesPage';
import RevenuesPage from './pages/RevenuesPage';
import ExpensesPage from './pages/ExpensesPage';
import NewDashboardPage from './pages/NewDashboardPage';
import ReportsPage from './pages/ReportsPage';
import InvoicesPage from './pages/InvoicesPage';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import CashFlowReport from './pages/CashFlowReport';
import AlertsPage from './pages/AlertsPage';
import LoginPage from './pages/LoginPage';
import SettingsPage from './pages/SettingsPage';
import ProvidersPage from './pages/ProvidersPage';
import CustomersPage from './pages/CustomersPage';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import UpdatePrompt from './pwa/UpdatePrompt';
import TransfersPage from './pages/TransfersPage';
import AccountsReceivablePage from './pages/AccountsReceivablePage';
import AccountsPayablePage from './pages/AccountsPayablePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import DailySummaryPage from './pages/DailySummaryPage';
import AdminCompaniesPage from './pages/admin/AdminCompaniesPage';
import AdminCompanyDetailPage from './pages/admin/AdminCompanyDetailPage';
import AdminPlansPage from './pages/admin/AdminPlansPage';
import AdminSystemsPage from './pages/admin/AdminSystemsPage';
import AdminSystemDetailPage from './pages/admin/AdminSystemDetailPage';
import UsersPage from './pages/admin/UsersPage';
import VerifyEmailPage from './pages/VerifyEmailPage';

// Layout component to render Navbar for protected routes
const AppLayout = () => {
  const { isAuthenticated } = useAuth();
  return (
    <>
      {isAuthenticated && <Navbar />}
      <div className="container mt-4">
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />

          {/* Protected Routes */}
          <Route path="/" element={<ProtectedRoute><NewDashboardPage /></ProtectedRoute>} />
          <Route path="/banks" element={<ProtectedRoute><BanksPage /></ProtectedRoute>} />
          <Route path="/credit-cards" element={<ProtectedRoute><CreditCardsPage /></ProtectedRoute>} />
          <Route path="/categories" element={<ProtectedRoute><CategoriesPage /></ProtectedRoute>} />
          <Route path="/revenues" element={<ProtectedRoute><RevenuesPage /></ProtectedRoute>} />
          <Route path="/expenses" element={<ProtectedRoute><ExpensesPage /></ProtectedRoute>} />
          <Route path="/transfers" element={<ProtectedRoute><TransfersPage /></ProtectedRoute>} />
          <Route path="/accounts-receivable" element={<ProtectedRoute><AccountsReceivablePage /></ProtectedRoute>} />
          <Route path="/accounts-payable" element={<ProtectedRoute><AccountsPayablePage /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><NewDashboardPage /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
          <Route path="/reports/cash-flow" element={<ProtectedRoute><CashFlowReport /></ProtectedRoute>} />
          <Route path="/daily-summary" element={<ProtectedRoute><DailySummaryPage /></ProtectedRoute>} />
          <Route path="/invoices" element={<ProtectedRoute><InvoicesPage /></ProtectedRoute>} />
          <Route path="/invoices/:id" element={<ProtectedRoute><InvoiceDetailPage /></ProtectedRoute>} />
          <Route path="/alerts" element={<ProtectedRoute><AlertsPage /></ProtectedRoute>} />
          <Route path="/providers" element={<ProtectedRoute><ProvidersPage /></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><CustomersPage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute role="admin"><SettingsPage /></ProtectedRoute>} />

          {/* Admin Backoffice (super_admin only) */}
          <Route path="/admin" element={<ProtectedRoute role="super_admin"><AdminDashboardPage /></ProtectedRoute>} />
          <Route path="/admin/companies" element={<ProtectedRoute role="super_admin"><AdminCompaniesPage /></ProtectedRoute>} />
          <Route path="/admin/companies/:id" element={<ProtectedRoute role="super_admin"><AdminCompanyDetailPage /></ProtectedRoute>} />
          <Route path="/admin/plans" element={<ProtectedRoute role="super_admin"><AdminPlansPage /></ProtectedRoute>} />
          <Route path="/admin/systems" element={<ProtectedRoute role="super_admin"><AdminSystemsPage /></ProtectedRoute>} />
          <Route path="/admin/systems/:systemId" element={<ProtectedRoute role="super_admin"><AdminSystemDetailPage /></ProtectedRoute>} />
          <Route path="/admin/user-roles" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
        </Routes>
      </div>
    </>
  );
};


function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <AppLayout />
          <UpdatePrompt />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
